import { useCallback } from "react";
import { useTranslate } from "@made-people/grease-translations";
import { FaqQnaItems } from "./faq-qna-items";
import { parseFaqItems } from "./parse-faq-items";
import { faqEventEmitter } from "./faq-event-emitter";

export const CategoryFaq = ({
  faq,
  category,
}: {
  faq: unknown;
  category?: string;
}) => {
  const translate = useTranslate();
  const items = parseFaqItems(faq);

  const handleQuestionOpen = useCallback(
    (question: string) => {
      faqEventEmitter.emit("faqClicked", {
        question,
        variant: "plp",
        productSku: null,
        category: category ?? null,
      });
    },
    [category],
  );

  if (!items.length) return null;

  return (
    <div className="mx-auto mb-2 mt-4 w-full max-w-screen-page-max-width rounded-md px-6 py-10 lg:mt-0 lg:flex lg:gap-x-16">
      <h2 className="font-secondary text-heading-md lg:text-heading-xl text-left pb-6 lg:w-1/2 lg:flex-shrink-0 lg:pb-0">
        {translate("FAQ_title_pdp_plp")}
      </h2>
      <div className="lg:w-1/2">
        <FaqQnaItems items={items} onQuestionOpen={handleQuestionOpen} />
      </div>
    </div>
  );
};
